export const actions = {
  CPS_LOAD_RESTRICCIONES_MOVILIDAD_REQUESTED: 'CPS_LOAD_RESTRICCIONES_MOVILIDAD_REQUESTED',
  CPS_LOAD_RESTRICCIONES_MOVILIDAD_SUCCEEDED: 'CPS_LOAD_RESTRICCIONES_MOVILIDAD_SUCCEEDED',
  CPS_LOAD_RESTRICCIONES_MOVILIDAD_FILED: 'CPS_LOAD_RESTRICCIONES_MOVILIDAD_FILED',
}

export const getCodigosPostalesAction = dispatch => {
  dispatch({
    type: actions.CPS_LOAD_RESTRICCIONES_MOVILIDAD_REQUESTED,
  })
}
